import React, { type ComponentProps } from 'react';
import { Button, Flex, Box } from '@skin-seoul/design-system';
import { COLORS, FONT_FAMILIES } from '../constants';
type ButtonProps = ComponentProps<typeof Button>;
type FlexProps = ComponentProps<typeof Flex>;
type BoxProps = ComponentProps<typeof Box>;
export const SelectButton = React.forwardRef<HTMLButtonElement, {
  children: React.ReactNode;
  onClick: () => void;
} & Omit<ButtonProps, 'children' | 'onClick'>>(({
  children,
  onClick,
  ...props
}, ref) => <Button ref={ref} onClick={onClick} w="full" display="inline-flex" alignItems="center" justifyContent="space-between" h="36px" px="12px" bg="generic.0" border="1px solid" borderColor="neutral.100" borderRadius="8px" color="neutral.700" textStyle="paragraph.small" cursor="pointer" whiteSpace="nowrap" gap="16px" _hover={{
  bg: 'neutral.50'
}} _focus={{
  outline: 'none',
  borderColor: 'primary.400'
}} {...props}>
    {children}
  </Button>);
SelectButton.displayName = 'SelectButton';
export const OptionsList = React.forwardRef<HTMLDivElement, {
  children: React.ReactNode;
} & Omit<FlexProps, 'children'>>(({
  children,
  ...props
}, ref) => <Flex ref={ref} direction="column" gap={{
  base: '16px',
  tablet: '10px'
}} {...props}>
    {children}
  </Flex>);
OptionsList.displayName = 'OptionsList';
export const OptionItem = ({
  children,
  isSelected,
  onClick,
  style,
  ...props
}: {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
} & Omit<FlexProps, 'children' | 'onClick'>) => <Flex align="center" justify="space-between" w="full" p={{
  base: '0',
  tablet: '16px'
}} textAlign="left" cursor="pointer" style={{
  fontSize: '14px',
  ...style
}} color={isSelected ? COLORS.primary : COLORS.textSecondary} fontFamily={FONT_FAMILIES.primary} _hover={{
  backgroundColor: '#f5f5f5'
}} onClick={onClick} {...props} data-sentry-element="Flex" data-sentry-component="OptionItem" data-sentry-source-file="styles.tsx">
    {children}
  </Flex>;
export const CheckIcon = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & Omit<BoxProps, 'children'>) => <Box as="span" color={COLORS.primary} style={{
  fontSize: '18px'
}} {...props} data-sentry-element="Box" data-sentry-component="CheckIcon" data-sentry-source-file="styles.tsx">
    {children}
  </Box>;